import { BrowserXhr, ResponseOptions, XSRFStrategy, XHRBackend, Request, XHRConnection, Response } from '@angular/http';
import { Observable } from 'rxjs';
import { Subject } from 'rxjs/Subject';
import { Router } from '@angular/router';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';

export class MyXHRBackend extends XHRBackend {

	static emitter: Subject<any> = new Subject();

	createConnection(request: Request): XHRConnection {
		let connection: XHRConnection = super.createConnection(request);
		connection.response = connection.response.catch(this.processResponse); // Before returning the connection we try to catch all possible errors(4XX, 5XX and so on...)
		return connection;
	}

	processResponse(response: Response) {
		console.log("RAW RESPONSE:", response);

		MyXHRBackend.emitter.next({
			errorCode: response.status,
			errorDescription: response.statusText
		});

		return Observable.throw(response);
	}
}



// WEBPACK FOOTER //
// ./src/app/MyXHRBackend.ts